import { render } from "./Preloader.vue?vue&type=template&id=12a051b0&scoped=true"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"

import "./Preloader.vue?vue&type=style&index=0&id=12a051b0&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-meter-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a051b0"],['__file',"src/assets/js/components/Preloader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12a051b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12a051b0', __exports__)) {
    api.reload('12a051b0', __exports__)
  }
  
  module.hot.accept("./Preloader.vue?vue&type=template&id=12a051b0&scoped=true", () => {
    api.rerender('12a051b0', render)
  })

}


export default __exports__